export const INVALID_VALUE = "「{{path}}」は無効です。";
export const INVALID_NOT_EMPTY = "「{{path}}」を入力してください。";
export const INVALID_ALREADY_EXISTS = "「{{path}}」はすでに存在しています。";
export const INVALID_SELECT_NOT_EMPTY = "「{{path}}」を選択してください。";
export const INVALID_EMAIL = "無効なメールアドレスです。";
export const INVALID_URL = "無効なURL形式です。";
export const INVALID_BOOLEAN = "真偽値で入力する必要があります。";
export const INVALID_LIMIT = "「{{path}}」は「{{max}}」以下を入力してください。";
export const INVALID_CP932_CHARACTER = "次の使用できない文字が含まれています：{{path}}";
export const INVALID_PRODUCT_CONTRACT_NOT_EMPTY = "プロダクトアクセス権限を1つ以上選択してください。";
// Mirrors the row-error format the import validate API returns, so both sets read the same in the list.
export const INVALID_IMPORT_PRODUCT_NOT_EMPTY = "{{row}}行目:「プロダクトアクセス権限」を入力してください。";

export const INVALID_NUMBER = "「{{path}}」は数字で入力してください。";
export const INVALID_NUMBER_INTEGER = "「{{path}}」には整数を入力してください。";
export const INVALID_NUMBER_POSITIVE = "「{{path}}」は0以上を入力してください。";
export const INVALID_NUMBER_NEGATIVE = "「{{path}}」は0以下を入力してください。";
export const INVALID_NUMBER_MIN = "「{{path}}」は「{{min}}」以上を入力してください。";
export const INVALID_NUMBER_MAX = "「{{path}}」は「{{max}}」以下を入力してください。";
export const INVALID_NUMBER_LESS_THAN = "「{{path}}」は「{{less}}」より小さな値を入力してください。";
export const INVALID_NUMBER_MORE_THAN = "「{{path}}」は「{{more}}」より大きな値を入力してください。";

export const INVALID_STRING_LENGTH = "「{{path}}」は「{{length}}」文字で入力してください。";
export const INVALID_STRING_MIN = "「{{path}}」は少なくとも「{{min}}」文字以上で入力してください。";
export const INVALID_STRING_MAX = "「{{path}}」は最大「{{max}}」文字で入力してください。";
export const INVALID_STRING_MATCHES = "「{{path}}」の形式が正しくありません。";
export const INVALID_LETTER_ONLY = "「{{path}}」にスペース以外の記号は使用できません。";
export const INVALID_STRING_KATAKANA = "「{{path}}」はカタカナを入力してください。";
export const INVALID_STRING_FURIGANA = "「{{path}}」はふりがなで入力してください。";
export const INVALID_STRING_ROMAJI = "「{{path}}」はローマ字で入力してください。";
export const INVALID_STRING_HALF_WIDTH = "「{{path}}」の形式が正しくありません。";
export const INVALID_STRING_UPPERCASE_AND_NUMBER = "「{{path}}」は半角英数字の大文字を入力してください。";
export const INVALID_STRING_LATIN = "「{{path}}」は半角英字を入力してください。";
export const INVALID_STRING_DISALLOWED_CHARACTERS = "次の使用できない文字が含まれています：{{characters}}";
export const INVALID_STRING_FULL_WIDTH = "「{{path}}」は全角文字を入力してください。";
export const INVALID_NOT_JP_COMMA = "「{{path}}」に句読点（、）は使用できません。";
export const INVALID_NOT_NORMAL_COMMA = "「{{path}}」にカンマ（,）は使用できません。";
export const INVALID_NOT_COMMA = "「{{path}}」にカンマ（,）および句読点（、）は使用できません。";
export const INVALID_TRIMMED = "{{path}}」は前後に空白のない文字列で入力してください。";
export const INVALID_NOT_SYMBOL = "「{{path}}」にスペース以外の記号は使用できません。";

export const INVALID_PASSWORD_STRONG = "パスワードはアルファベット大文字・小文字・数字・記号を含む12文字以上で入力してください。";
export const INVALID_PASSWORD_CONFIRM = "確認パスワードが一致しません。";
export const INVALID_CURRENT_PASSWORD = "現在のパスワードが正しくありません。";
// Google-only accounts (no password set) can't set a password from this screen.
export const INVALID_PASSWORD_NOT_ALLOWED = "パスワードが設定されていないため、この画面では変更できません。";

export const INVALID_DATE = "「{{path}}」の日付が正しくありません。";
export const INVALID_BEFORE_AGE = "「{{path}}」は、{{age}}歳以上の日付を選択してください。";
export const INVALID_DATE_MUST_AFTER = "「{{end}}」は「{{start}}」より後にする必要があります。";
export const INVALID_DATE_MUST_BEFORE = "「{{start}}」は「{{end}} より前にする必要があります";
export const INVALID_DATE_MUST_PAST = "{{path}}は、今日より前の日付を入力してください。";
export const INVALID_DATE_MUST_PAST_OR_TODAY = "{{path}}は、今日もしくは前の日付を入力してください。";

export const INVALID_ZIP_CODE_FORMAT = "「郵便番号」は7数字で入力してください。";

export const INVALID_ZIP_CODE = "入力された郵便番号が無効です。正しい郵便番号を入力してください。";

export const INVALID_LAND_LINE_TEL_NUMBER =
  "固定電話番号の形式が正しくありません。例：03-1234-5678 の形式で入力してください。携帯電話番号（050、060、070、080、090等で始まる番号）は使用できません。";

export const INVALID_MOBILE_TEL_NUMBER = "携帯電話番号の形式が正しくありません。例：090-1234-5678 の形式で入力してください。";

export const REQUIRED_TRANSLATION = "日本語の内容が変更されています。再度翻訳または入力してください。";

export const REQUIRED_MUST_BE_AVAILABLE = "所属機関情報の事業所管理の「事業所名（ローマ字）」を入力してください。";

export const INVALID_JAPAN_TEL_NUMBER = "電話番号の形式が正しくありません。例：090-1234-5678 の形式で入力してください。";

export const REQUIRED_FILE_OR_ALREADY_UPDATE_CHECKBOX = "ファイル選択か不要としてください";

export const INVALID_TIME_HH_MM = "時間はHH:mm形式で入力してください。";

export const INVALID_POSITION_SUPPORT_PLAN = "「支援担当者（役職）」を登録してください。";

export const INVALID_PASSWORD_PROTECTED_PDF = "パスワード付きPDFはアップロードできません。PDFはパスワードを設定せずにご用意ください。";

export const INVALID_PDF_FORMAT = "アップロードされたファイルが正しいPDF形式でないため、アップロードできません。";

export const INVALID_FILE_FORMAT = "アップロード可能なファイル形式は{{types}}です。";
